<script setup lang="ts">
// import { usePageStore } from "../stores";

// const page = usePageStore();
</script>

<template>
  <main class="flex gap-4 h-screen p-10">
    <div class="grow flex items-center justify-center">
      <div class="border w-[380px] max-w-[80%] px-7 py-10 rounded-md">
        <slot />
      </div>
    </div>

    <!-- <div class="max-w-[50%] w-[50%] shrink-0 relative overflow-hidden border h-full p-10 rounded-md">
      <img :src="authImage" alt="Auth Background" class="absolute inset-0 w-full h-full object-cover" />

      <div class="relative z-10">
        <img v-if="page.appLogo" :src="page.appLogo" alt="App Logo" class="brand-logo-img mb-4" />

        <h1 class="text-2xl font-medium">{{ page.appName }}</h1>

        <p v-if="!!page.appDescription" class="max-w-[55%] mt-4 leading-[1.6] text-md">
          {{ page.appDescription }}
        </p>
      </div>
    </div> -->
  </main>
</template>

<style scoped>
.brand-logo-img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}
</style>
